import { useRequest } from 'ahooks'
import { shopStore } from '@/store/shop'
import { getShopInfo } from '../api'

export const useMemberSettingAccess = () => {
    const request = useRequest(getShopInfo, {
        onSuccess: shopInfo => shopStore.setShopInfo(shopInfo),
    })
    const shopInfo = request.data || shopStore.shopInfo

    return {
        loading: request.loading,
        readOnly: shopInfo?.shop_type === 1,
    }
}
